@if (routeId) {
  <app-optimization-run-stops-table [optimizationRunId] = "routeId"/>
}
<app-mdb-button (onClick)="goingBack()"
                [text]="'ROUTES.BACK'"
                color="secondary"/>
